// Aeonyx official brand assets (hosted CDN)
export const AEONYX_ICON_URL =
  "https://customer-assets.emergentagent.com/job_peptide-protection/artifacts/53hyv3cl_aeonyx_Logo.webp";

export const AEONYX_WORDMARK_URL =
  "https://customer-assets.emergentagent.com/job_peptide-protection/artifacts/cezea15h_aeonyx_wordmark_4k.webp";

const BASE_IMG_STYLES = {
  imageRendering: "auto",
  objectFit: "contain",
};

/** Standalone A + DNA icon. Height controlled via className (e.g. h-9, h-12). */
export function AeonyxIcon({ className = "h-10 w-auto", priority = false }) {
  return (
    <img
      src={AEONYX_ICON_URL}
      alt="Aeonyx Life Sciences Logo"
      className={className}
      style={BASE_IMG_STYLES}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      draggable={false}
    />
  );
}

/**
 * Full horizontal wordmark (Aeonyx + Life Sciences).
 * Size is controlled by height utility on className, width auto preserves aspect ratio.
 * Default responsive height: 38→46→52→56→60px.
 */
export function AeonyxWordmark({
  className = "h-[38px] md:h-[46px] lg:h-[52px] xl:h-[56px] 2xl:h-[60px] w-auto",
  priority = false,
}) {
  return (
    <img
      src={AEONYX_WORDMARK_URL}
      alt="Aeonyx Life Sciences Logo"
      className={className}
      style={BASE_IMG_STYLES}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      draggable={false}
      data-testid="aeonyx-wordmark"
    />
  );
}

/**
 * Composed lockup for tight spaces (compliance modal, dark cards).
 * Uses the icon plus a lightweight text label — for full nav / footer, prefer AeonyxWordmark.
 */
export function AeonyxLockup({ className = "", iconClassName = "h-10 w-auto" }) {
  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <AeonyxIcon className={iconClassName} priority />
      <span className="inline-flex flex-col leading-none">
        <span className="font-display font-bold text-[20px] tracking-tight text-navy-deep">
          Aeonyx
        </span>
        <span className="font-mono-data text-[9px] tracking-[0.32em] mt-0.5 opacity-70 uppercase text-navy-deep">
          Life Sciences
        </span>
      </span>
    </div>
  );
}
